import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {environment} from '../../environments/environment';
import {
  ICertificateOverview,
  ICertificateReminderRequest,
} from '../shared/model/certificate-overview.model';

type MilestonePayload = Record<string, {
  trainingPlanned: string | null;
  trainingDate: string | null;
  examDate: string | null;
  certifiedDate: string | null;
}>;

@Injectable({providedIn: 'root'})
export class CertificateOverviewService {
  private overviewUrl = environment.apiConfig.uri + 'api/zeugnisse/uebersicht';
  private reminderUrl = environment.apiConfig.uri + 'api/zeugnisse/erinnerung';
  private beraterUrl = environment.apiConfig.uri + 'api/berater';

  constructor(private http: HttpClient) {}

  getOverview(): Observable<ICertificateOverview[]> {
    return this.http.get<ICertificateOverview[]>(this.overviewUrl);
  }

  sendReminder(request: ICertificateReminderRequest): Observable<void> {
    return this.http.post<void>(this.reminderUrl, request);
  }

  updateMilestones(consultantId: string, milestones: MilestonePayload): Observable<void> {
    return this.http.patch<void>(`${this.beraterUrl}/${consultantId}/certificate-milestones`, { milestones });
  }
}
